/**
 * CSRSignOut.jsx
 * Created by Hassan Riaz on 1/16/20.
 */

import React from 'react';
import PropTypes from 'prop-types';

import CartIndicator from '../../sharedComponents/CartIndicator';
import CSRProfileDropdown from './CSRProfileDropdown';

import { ACCOUNT_PROPS, CSR_ACCOUNT_PROPS } from '../constants';

export default class CSRSignOut extends React.PureComponent {
    static propTypes = {
        cart: PropTypes.shape({
            expiration: PropTypes.string,
            showTimer: PropTypes.bool,
            reservations: PropTypes.array
        }),
        account: ACCOUNT_PROPS,
        csrAccount: CSR_ACCOUNT_PROPS,
        logout: PropTypes.func,
        openSelectCustomerModal: PropTypes.func
    };

    render() {
        return (
            <div className="nav-user-actions">
                <CartIndicator cart={this.props.cart} />
                <CSRProfileDropdown
                    account={this.props.account}
                    csrAccount={this.props.csrAccount}
                    openSelectCustomerModal={this.props.openSelectCustomerModal}
                    signOut={this.props.logout} />
            </div>
        );
    }
}
